import { NgModule } from '@angular/core';
import { LoadingSpinnerComponent } from './loading-spinner.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@NgModule({
	imports: [
        CommonModule,
        FormsModule
    ],
	declarations: [LoadingSpinnerComponent],
	exports: [LoadingSpinnerComponent],
})

export class LoadingSpinnerModule {}
